export interface ILocationInputDto {
    name: string;
    externalId?: string;
    code: string;
    zones?: string[];
    addressLine1?: string;
    isWarehouse?: boolean;
    addressLine2?: string;
    city?: string;
    state?: string;
    country?: string;
    latitude?: string;
    longitude?: string;
    tags?: string[];
    contactEmail?: string;
    contactPhone?: string;
    isStopOver?: boolean;
}
